function Loader() {
  return (
    <div className="state loader-container">
      <div className="loader"></div>
      <p>Loading questions...</p>
    </div>
  );
}

export default Loader;
